import type { Melody } from '@tunasong/schemas'
import type { FC } from 'react'
import styles from './melody-mini-roll.module.css'
import { MelodyRoll } from './melody-roll.js'

/**
 * The compact, read-only roll the melody BLOCK renders (§3): pitch range auto-fit, one row of
 * bars, and a tempo/meter badge.
 *
 * It is the same `MelodyRoll` without `onChange`, not a second drawing of the same data - two
 * renderers would drift, and the block's job is to show the melody as the editor shows it, only
 * smaller.
 *
 * Spec: docs/superpowers/specs/2026-09-08-melody-plugin-design.md §3
 */

export interface MelodyMiniRollProps {
  melody: Melody
  /** ms from the start of playback, so the block's play button can run a head too. */
  playheadMs?: number | null
  className?: string
}

export const MelodyMiniRoll: FC<MelodyMiniRollProps> = props => {
  const { melody, playheadMs, className } = props
  const { bpm, meter } = melody.tempo

  return (
    <div className={className ? `${styles.root} ${className}` : styles.root}>
      <span className={styles.badge}>{`${bpm} bpm · ${meter.top}/${meter.bottom}`}</span>
      {melody.notes.length === 0 ? (
        <span className={styles.empty}>No notes yet</span>
      ) : (
        <MelodyRoll melody={melody} playheadMs={playheadMs} compact={true} />
      )}
    </div>
  )
}
